import React from "react";
import { UpOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import BackTop from "@/components/BackTop";

const BackTopButton: React.FC = () => {
    return (
        <BackTop className="fr inline-block">
            <Tooltip title="回到顶部" autoAdjustOverflow={false}>
                <Button>
                    <UpOutlined />
                </Button>
            </Tooltip>
        </BackTop>
    );
};

export default React.memo(BackTopButton);
